<
<template>
    <div class="session-wrapper">
        <div class="session-right text-xs-center">
            <div class="session-table-cell">
                <div class="session-content">
                    <img :src="appLogo" class="img-responsive mb-4" style="max-width: 300px" />
                    <h2 class="mb-3">{{ $t("lang.signUp") }}</h2>
                    <p class="fs-14">{{ $t("lang.account_creation_opening_info") }}.</p>
                    <v-form ref="user_invite" class="mb-4">
                        <v-text-field
                            v-model="user_invite.username"
                            :label="`${$t('lang.username')} *`"
                            :counter="showCounter(user_invite.username, 'user_invite.username')"
                            :rules="ifValid('user_invite.username')"
                            @change="dbcheckUserNameAvail(user_invite.username)"
                        >
                            <template slot="append-outer">
                                <tooltip>
                                    <template slot="activator">
                                        <v-icon :color="availableUserName.exists ? 'error' : 'success'">{{
                                            availableUserName.exists ? "close" : "check"
                                        }}</v-icon>
                                    </template>
                                    {{ availableUserName.exists ? $t("lang.username_not_avail") : $t("lang.username_avail") }}
                                </tooltip>
                            </template>
                        </v-text-field>
                        <bc-password-input
                            v-model="user_invite.password"
                            :label="`${$t('lang.password')} *`"
                            :counter="showCounter(user_invite.password, 'user_invite.password')"
                            :rules="ifValid('user_invite.password')"
                        ></bc-password-input>
                        <bc-password-input
                            v-model="confirm_password"
                            :label="`${$t('lang.confirm_password')} *`"
                            :counter="showCounter(confirm_password, 'user_invite.confirm_password')"
                            :rules="ifValid('user_invite.confirm_password')"
                        ></bc-password-input>
                        <div class="mb-4">
                            <v-btn large @mouseup.left="updateUserInfo()" block color="primary">
                                {{ $t("lang.submit_information") }}
                            </v-btn>
                        </div>
                    </v-form>
                    <div>
                        <router-link to="/session/login">{{ $t("lang.backToSignIn") }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import AppConfig from "Constants/AppConfig";
import api from "Api";
import router from "Router";

export default {
    data() {
        return {
            login: "",
            new_request: {
                login: "",
            },
            confirm_password: null,
            appLogo: AppConfig.appLogo2,
            person: null,
            userId: "",
            user_invite: {
                username: "",
                password: "",
            },
            dbcheckUserNameAvail: _.debounce(this.checkUserNameAvail, 1000, { maxWait: 1500, leading: true, trailing: false }),
            availableUserName: {
                exists: true,
            },
        };
    },
    mounted: function () {
        this.getPeople();
    },
    computed: {
        ...mapState({
            rules_user_invite: (state) => state.validation.rules_user_invite,
        }),
    },
    methods: {
        getPeople() {
            this.$store
                .dispatch("fetchPeople", {
                    url: "people/accept_invite/" + this.$route.params.token + "/" + this.$route.params.people_id,
                    method: "get",
                })
                .then((data) => {
                    if (data) {
                        this.userId = data.person.user_id;
                    }
                    this.finishLoader();
                });
        },
        updateUserInfo() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("user_invite")) {
                    this.$store
                        .dispatch("fetchUsers", {
                            url: "users/signup/" + this.$route.params.token + "/" + this.userId,
                            method: "patch",
                            body: this.user_invite,
                        })
                        .then(() => {
                            this.$store.commit("validationOff");
                            //this.$router.push({ path: `/session/login` });
                            this.$router.push({ name: "login" });
                        });
                }
            });
        },
        checkUserNameAvail(username) {
            let validateUserName = {
                username: username,
                invite_token: "test",
            };
            if (this.$refs.user_invite.validate()) {
                this.$store
                    .dispatch("fetchUsers", {
                        url: "users/name_check",
                        method: "post",
                        body: validateUserName,
                    })
                    .then((data) => {
                        if (typeof data !== "undefined") {
                            this.availableUserName.exists = data.users.exists;
                        }
                    });
            } else {
                this.availableUserName.exists = true;
            }
        },
    },
};
</script>
